<template>
  <base-section
    id="nos-produits"
    class="secondary"
  >
    <base-section-heading
      class="white--text"
      title="Nos produits"
    >
    </base-section-heading>
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="produit in produits"
            :key="produit.nom"
            cols="12"
            sm="12"
            md="4"
            lg="4"
          >
            <v-card
              style="padding:10px;"
              class="mx-auto"
            >
              <v-img
                class="white--text align-center"
                height="200px"
                contain
                style="background-size:contain"
                :src="produit.image"
              >
              </v-img>

              <v-card-text style="padding-bottom: 0;" class="text--primary">
                <div>{{produit.nom}}</div>
              </v-card-text>

              <v-card-actions>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionNosProduits',

    methods : {
      getImage(p){
        return ""
      }
    },
    data: () => ({
      produits: [
        {
          nom: 'Crystalline H20 Pot de 300 grammes',
          image: require('@/assets/produits/300g.png'),
        },
        {
          nom: 'Crystalline H20 Pot de 700 grammes',
          image: require('@/assets/produits/500g.png'),
        },
        {
          nom: 'Crystalline H20 Pot de 1.3Kg',
          image: require('@/assets/produits/1300g.png'),
        },
        {
          nom: 'Nettoyant Ligne Eau',
          image: require('@/assets/produits/143.png'),
        },
        {
          nom: 'Répulsif Mouches',
          image: require('@/assets/produits/122.png'),
        },
        {
          nom: 'Répulsif Moustiques',
          image: require('@/assets/produits/123.png'),
        },
      ],
    }),
  }
</script>
